import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { Header } from './header';
import { Footer } from './footer';
import { ScrollToTop } from './scroll-to-top';
import { CookieConsent } from '../privacy/cookie-consent';
import {
  getJourneyContext,
  trackDelegatedConversionClick,
  trackPageView,
} from '@/lib/analytics';

export function RootLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    // First touch remains session-local until the consent gate permits sending.
    getJourneyContext(pathname);
    trackPageView(pathname);
  }, [pathname]);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      trackDelegatedConversionClick(event, pathname);
    };
    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-surface-50">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
